import React, { lazy, Suspense } from "react";
import ExecutionEnvironment from "exenv";

// Components
import CustomMeta from "../components/CustomMeta/CustomMeta";

// MUI stuff
import { Typography } from "@mui/material";

const SavingsCalculator = lazy(() =>
  import(
    /* webpackChunkName: "SavingsCalculator" */ "../components/SavingsCalculator/SavingsCalculator"
  )
);

import { makeStyles } from "tss-react/mui";

// redux stuff
import { connect } from "react-redux";

const useStyles = makeStyles()(() => ({
  mainDiv: {
    padding: 30,
    textAlign: "center",
  },
  fullPageHeight: {
    minHeight: "100vh",
    width: "100%",
  },
  subtitleText: {
    marginBottom: 30,
  },
}));

function savingsCalculator() {
  const { classes } = useStyles();

  return (
    <div className={classes.fullPageHeight}>
      <CustomMeta
        title={`Savings Calculator - Content Generator`}
        description={`Discover how much time and money you can save with Content Generator's automation tools. Calculate your potential ROI for social media marketing, including design costs, content creation time, and scheduling efficiency.`}
        url={`https://contentgenerator.io/savings-calculator`}
      />
      <div className={classes.mainDiv}>
        <Typography variant="h1">Savings Calculator</Typography>
        <Typography className={classes.subtitleText}>
          Calculate how much time and money you can save by using Content
          Generator.
        </Typography>
        {ExecutionEnvironment.canUseDOM && (
          <Suspense fallback={<div />}>
            <SavingsCalculator />
          </Suspense>
        )}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  data: state.data,
});

export default connect(mapStateToProps)(savingsCalculator);
